import React, {useState, useEffect} from "react";
import moment from "moment";
import CustomLoader from "../../CustomComponents/CustomLoader";
import {GetUpliftsService} from "../../services/contractorServices";
import {issueLabels} from "../../constant";
import CustomUserName from "../../CustomComponents/CustomUserName";
import Box from "@mui/material/Box";
import CustomUserProfile from "../../CustomComponents/CustomUserProfile";

const MyUplifts = () => {
	const [loading, setLoading] = useState(true);
	const [upliftsData, setUpliftsData] = useState([]);
	const [filterType, setFilterType] = useState("all"); // all, ratings, comments
	const [searchTerm, setSearchTerm] = useState("");

	// Fetch uplifts data from API
	const fetchUpliftsData = async () => {
		try {
			setLoading(true);
			const response = await GetUpliftsService();

			if (response && response.status === true && Array.isArray(response.data)) {
				setUpliftsData(response.data);
			} else {
				setUpliftsData([]);
			}
		} catch (error) {
			console.error("Error fetching uplifts data:", error);
			setUpliftsData([]);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchUpliftsData();
	}, []);

	const handleFilterTypeChange = (newType) => {
		setFilterType(newType);
	};

	const renderStars = (rating) => {
		return [...Array(5)].map((_, index) => (
			<span key={index} className={`star ${index < rating ? "filled" : ""}`}>
				★
			</span>
		));
	};

	const getRatingColor = (rating) => {
		if (rating >= 4) return "rating-excellent";
		if (rating >= 3) return "rating-good";
		if (rating >= 2) return "rating-fair";
		return "rating-poor";
	};

	const getStatusBadge = (isHistoric, adminFlagged) => {
		if (adminFlagged) {
			return <span className="badge badge-danger">Flagged</span>;
		}
		return isHistoric ? <span className="badge badge-warning">Historic</span> : <span className="badge badge-success">Fresh</span>;
	};

	// Filter data based on search and filters
	const filteredData = upliftsData.filter((item) => {
		const matchesType = filterType === "all" || (filterType === "ratings" && item.rating_id !== null);

		const address = item.address?.full_address || "";
		const userName = `${item.user.first_name} ${item.user.last_name}`;
		const jobIssues = Array.isArray(item.job_issues) ? item.job_issues.join(" ") : "";

		const matchesSearch =
			searchTerm === "" ||
			address.toLowerCase().includes(searchTerm.toLowerCase()) ||
			userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
			jobIssues.toLowerCase().includes(searchTerm.toLowerCase());

		return matchesType && matchesSearch;
	});

	// Calculate stats
	const totalUplifts = upliftsData.length;
	const totalRatingsUplifted = upliftsData.filter((item) => item.rating_id !== null).length;

	return (
		<div className="dashboard-page">
			<div className="page-header">
				<h2>My Uplifts</h2>
				<p>View and manage all your uplifted ratings ({totalUplifts} total)</p>
			</div>

			{/* Stats Cards */}
			{/* <div className="stats-grid">
				<div className="stat-card">
					<div className="stat-icon stat-icon-warning">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{totalUplifts}</div>
						<div className="stat-label">Total Uplifts</div>
					</div>
				</div>

				<div className="stat-card">
					<div className="stat-icon stat-icon-success">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" />
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{totalRatingsUplifted}</div>
						<div className="stat-label">Ratings Uplifted</div>
					</div>
				</div>

				<div className="stat-card">
					<div className="stat-icon stat-icon-info">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
							<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" />
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{upliftsData.filter((item) => item.is_historic).length}</div>
						<div className="stat-label">Historic Ratings</div>
					</div>
				</div>
			</div> */}

			{/* Filters and Search */}
			{/* <div className="ratings-controls">
				<div className="search-section">
					<div className="search-input-wrapper">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="search-icon">
							<circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
							<path d="m21 21-4.35-4.35" stroke="currentColor" strokeWidth="2" />
						</svg>
						<input type="text" className="search-input" placeholder="Search by address, user, or job issues..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
						{searchTerm && (
							<button className="clear-search" onClick={() => setSearchTerm("")} title="Clear search">
								<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
									<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" />
								</svg>
							</button>
						)}
					</div>
				</div>

				<div className="filter-section">
					<select className="filter-select" value={filterType} onChange={(e) => handleFilterTypeChange(e.target.value)}>
						<option value="all">All Types</option>
						<option value="ratings">Ratings Only</option>
					</select>
				</div>
			</div> */}

			{/* Uplifts List */}
			{loading ? (
				<div className="ratings-container">
					<CustomLoader />
				</div>
			) : (
				<div className="ratings-container">
					{filteredData.length === 0 ? (
						<div className="no-ratings">
							<div className="placeholder-icon">
								<svg width="80" height="80" viewBox="0 0 24 24" fill="none">
									<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
								</svg>
							</div>
							<h3>No uplifted items found</h3>
							<p>{searchTerm ? "Try adjusting your search criteria" : "You haven't uplifted any ratings yet"}</p>
						</div>
					) : (
						<div className="ratings-grid">
							{filteredData.map((item) => (
								<div key={item.rating_id} className="rating-card">
									<div className="rating-card-header">
										<div className="address-info">
											<h4 className="job-address">{item.address?.full_address || "N/A"}</h4>
											<div className="rating-info">
												<div className="item-type-badge">
													<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
														<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
													</svg>
													<span>Uplifted Rating</span>
												</div>
												<span className="comment-date">{moment(item.job_date).format("MMM DD, YYYY")}</span>
											</div>
										</div>
									</div>

									<div className="rating-card-body">
										<div className="rating-display">
											<div className={`rating-stars ${getRatingColor(item.stars)}`}>
												{renderStars(item.stars)}
												<span className="rating-number">({item.stars}/5)</span>
											</div>
											{item.job_issues && item.job_issues.length > 0 && (
												<div className="issues-list">
													{item.job_issues.slice(0, 2).map((issue, index) => (
														<span key={index} className="issue-tag">
															{issueLabels[issue] || issue.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
														</span>
													))}
													{item.job_issues.length > 2 && <span className="issue-tag more">+{item.job_issues.length - 2} more</span>}
												</div>
											)}
										</div>

										<div className="job-details">
											<div className="detail-item">
												<span className="detail-label">Job Date:</span>
												<span className="detail-value">{moment(item.job_date).format("MMM DD, YYYY")}</span>
												<span className="days-ago">({moment().diff(moment(item.job_date), "days")} days ago)</span>
											</div>
											<div className="detail-item">
												<span className="detail-label">Status:</span>
												<span className="detail-value">{getStatusBadge(item.is_historic, item.admin_flagged)}</span>
											</div>
										</div>
									</div>

									<div className="rating-card-footer">
										<div className="item-meta">
											<div className="meta-item issue-tag">
												<svg width="14" height="14" viewBox="0 0 24 24" fill="none">
													<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" />
													<circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
												</svg>
												<span className="">
													<div className="d-flex gap-2 align-items-center">
														{/* By <CustomUserName user={item?.user} code /> */}
														By
														<Box sx={{display: "flex", alignItems: "center", gap: 1}}>
															<CustomUserProfile user={item?.user} width={30} sx={{fontSize: 12}} code />
															<CustomUserName user={item?.user} code sx={{fontSize: 13, color: "#000", fontWeight: 600}} />
														</Box>
													</div>
												</span>
											</div>
											<div className="meta-item">
												<svg width="14" height="14" viewBox="0 0 24 24" fill="none">
													<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2" />
												</svg>
												<span>Uplifted</span>
											</div>
										</div>
									</div>
								</div>
							))}
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default MyUplifts;
